<script setup>
import {computed} from 'vue'

const props = defineProps({
    value: String
})

const classNames = computed(() => {
    switch (props.value) {
        case 'Payment abandoned':
        case 'Payment failed':
        case 'Payment declined':
            return 'badge bg-danger'

        case 'Payment pending':
        case 'Payment accepted':
            return 'badge bg-warning'

        case 'Enquiry sent':
        case 'Payment complete':
        case 'Completed':
        case 'Refunded':
            return 'badge bg-success'

        default:
            return 'badge bg-secondary'
    }
})
</script>

<template>
    <span :class="classNames">{{ value }}</span>
</template>